import React from 'react';
import { useLocation } from 'react-router-dom';
import SalesReturnForm from './SalesReturnForm';

const NewSalesReturnPage = () => {
    // 1. Get optional query parameter (e.g., ?source_invoice_id=123)
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const sourceInvoiceId = query.get('source_invoice_id');

    // 2. Render form in 'create' mode, passing the source ID if it exists
    return (
        <SalesReturnForm 
            formType="create" 
            sourceInvoiceId={sourceInvoiceId} 
            currentId={null}
        />
    );
};

export default NewSalesReturnPage;